export default "__VITE_ASSET__9Im7GT3G__"